import { render, staticRenderFns } from "./AuthManagement.vue?vue&type=template&id=28e967b9&scoped=true&"
import script from "./AuthManagement.vue?vue&type=script&lang=js&"
export * from "./AuthManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e967b9",
  null
  
)

export default component.exports